const BACKEND_BUSY_MARKERS = {
  target_busy: "المستخدمة لديها مكالمة جارية حالياً",
  caller_busy: "لديك مكالمة جارية حالياً",
  pair_busy: "يوجد اتصال مفتوح بينكما بالفعل",
};

function readErrorReason(error) {
  const details = error?.details;

  if (typeof details === "string") {
    return details.trim().toLowerCase();
  }

  if (details && typeof details === "object") {
    return String(details.reason || "").trim().toLowerCase();
  }

  return "";
}

/**
 * Classifies a startCall callable failure.
 * @param {any} error Firebase callable error
 * @return {"target_busy"|"caller_busy"|"pair_busy"|"insufficient_balance"|null}
 */
export function getStartCallErrorKind(error) {
  const reason = readErrorReason(error);

  if (
    reason === "target_busy" ||
    reason === "caller_busy" ||
    reason === "pair_busy" ||
    reason === "insufficient_balance"
  ) {
    return reason;
  }

  const message = String(error?.message || "").trim();

  for (const [kind, marker] of Object.entries(BACKEND_BUSY_MARKERS)) {
    if (message.includes(marker)) {
      return kind;
    }
  }

  if (
    message.includes("الرصيد غير كاف") ||
    message.toLowerCase().includes("balance")
  ) {
    return "insufficient_balance";
  }

  return null;
}

/**
 * Resolves toast content for a startCall failure.
 * @param {Function} t i18next translate function
 * @param {any} error Firebase callable error
 * @param {string} [targetName] display name of the callee, for a
 *   name-aware target_busy message (Phase N9D) - falls back to the
 *   generic targetBusy wording when no name is available.
 * @return {{type: string, message: string}}
 */
export function getStartCallErrorToast(t, error, targetName) {
  const kind = getStartCallErrorKind(error);

  if (kind === "target_busy") {
    const name = String(targetName || "").trim();
    if (name) {
      return {
        type: "error",
        message: t("calls.errors.userBusyNamed", {
          defaultValue: "{{name}} is currently in another call.",
          name,
        }),
      };
    }
    return {
      type: "error",
      message: t("calls.errors.targetBusy", {
        defaultValue:
          "This user is currently busy in a call. Please try again later.",
      }),
    };
  }

  if (kind === "caller_busy") {
    return {
      type: "error",
      message: t("calls.errors.callerBusy", {
        defaultValue: "You are already in a call. Please end it first.",
      }),
    };
  }

  if (kind === "insufficient_balance") {
    return {
      type: "error",
      message: t("call_balance_error", {
        defaultValue: "Insufficient balance",
      }),
    };
  }

  return {
    type: "error",
    message: t("calls.errors.genericStartFailed", {
      defaultValue: "Failed to start the call. Please try again later.",
    }),
  };
}
